import React from 'react';

export default props => <h2 className="ListTitle" style={props.style}>{props.children}</h2>;
